import { SweetAlertResult } from 'sweetalert2';
import { makeStyles, Theme } from '@material-ui/core/styles';
import getBaseSweetAlert from './get-base-sweet-alert';
import { SweetAlertHookApi, OpenAlertOptions } from 'types';

const useStyles = makeStyles((theme: Theme) => ({
  title: {
    ...theme.typography.h2
  },
  container: {
    zIndex: theme.zIndex.modal + 1
  },
  content: {
    ...theme.typography.body1,
    marginTop: theme.spacing(2),
    fontWeight: 300,
    fontSize: '1.125em'
  },
  popup: {
    width: '28em',
    borderRadius: '8px'
  },
  confirmButton: {
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.pxToRem(16),
    lineHeight: theme.typography.pxToRem(21),
    backgroundColor: `${theme.palette.primary.main} !important`,
    borderRadius: '24px !important'
  },
  alertCancelButton: {
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.pxToRem(16),
    lineHeight: theme.typography.pxToRem(21),
    backgroundColor: `${theme.palette.common.white} !important`,
    color: `${theme.palette.grey[800]} !important`,
    border: `solid 1px ${theme.palette.grey[500]} !important`,
    padding: `${theme.spacing(1.375)}px ${theme.spacing(3.5)}px`,
    borderRadius: '24px !important'
  }
}));

const useSuccessAlert = (): SweetAlertHookApi => {
  const classes = useStyles();
  const SweetAlert = getBaseSweetAlert({
    icon: 'success',
    showConfirmButton: true,
    showCloseButton: false,
    showCancelButton: false,
    customClass: {
      title: classes.title,
      container: classes.container,
      content: classes.content,
      popup: classes.popup,
      confirmButton: classes.confirmButton,
      cancelButton: classes.alertCancelButton
    }
  });

  const open = (
    { onCancel, onSubmit, ...rest }: OpenAlertOptions = {} as OpenAlertOptions
  ): Promise<SweetAlertResult | void> => {
    return SweetAlert.fire(rest).then(async (result: SweetAlertResult | void) => {
      if (result && result.value && onSubmit) {
        return onSubmit(result);
      } else if (onCancel) {
        return onCancel();
      }
    });
  };

  return { open };
};

export default useSuccessAlert;
